import React, { useState, useEffect, useRef } from "react"
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext'
import { usePost } from '~/contexts/PostContext'
import { jnstyls, notBlank } from '~/utils/helpers'

import * as styles from "~/styles/blog/multicol.module.scss"
import * as bstyle from "~/styles/blog/blog.module.scss"

const Multicol = ({ blockId, index }) => {
  const { isMobile } = useTheme()
  const { post } = usePost()
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block

  const [openHeight, setOpenHeight] = useState(null)
  const [open, setOpen] = useState(true)
  const [showMore, setShowMore] = useState(false)
  const wrapRef = useRef(null)

  const mobi_blind_int = settings.more_lines_mobi && parseInt(settings.more_lines_mobi)
  const desk_blind_int = settings.more_lines_desk && parseInt(settings.more_lines_desk)

  const mobi_blind = (settings.more_mobi && (mobi_blind_int * 13 * 1.7)) || false
  const desk_blind = (settings.more_desk && (desk_blind_int * 13 * 1.7)) || false

  const heightCheck = () => {
    const height = wrapRef.current.getBoundingClientRect().height + 50
    setOpenHeight(height)

    let blind_h
    let show_more = false

    if (isMobile && mobi_blind && height > mobi_blind) {
      show_more = true
      blind_h = mobi_blind
    }

    if (!isMobile && desk_blind && height > desk_blind) {
      show_more = true
      blind_h = desk_blind
    }

    if (show_more) {
      wrapRef.current.style.maxHeight = `${blind_h}px`
      setOpen(false)
      setShowMore(true)
    }
  }

  useEffect(() => {
    if (!wrapRef.current) return
    heightCheck()
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrapRef])

  useEffect(() => {
    if (!showMore) return
    if (!wrapRef.current) return

    const close_height = isMobile ? mobi_blind : desk_blind
    wrapRef.current.style.maxHeight = open ? `${openHeight}px` : `${close_height}px`

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return (
    <div 
      className={jnstyls([bstyle.sec, styles.multicol, index === 0 ? bstyle.first : ''])} 
      block={block.id}
      ref={wrapRef}
    >

      {notBlank(settings.left_title) && (
        <h2 className={jnstyls([bstyle.title, styles.title])} dangerouslySetInnerHTML={{ __html: settings.left_title}} />
      )}
      {notBlank(settings.left_subtitle) && (
        <div className={jnstyls([bstyle.subtitle, styles.subtitle])} dangerouslySetInnerHTML={{ __html: settings.left_subtitle}} />
      )}

      <div className={styles.copy} dangerouslySetInnerHTML={{ __html: settings.copy}} />
      
      {(notBlank(settings.left_cta1) || notBlank(settings.left_cta2)) && (
        <div className={bstyle.copy_cta}>
          {notBlank(settings.left_cta1) && (
            <Flink href={settings.left_cta_link1} className={bstyle.cta_link}>
              <span>{settings.left_cta1}</span>
            </Flink>
          )}
          {notBlank(settings.left_cta2) && (
            <Flink href={settings.left_cta_link2} className={bstyle.cta_link}>
              <span>{settings.left_cta2}</span>
            </Flink>
          )}
        </div>
      )}
      {(showMore && !open) && (
        <div className={styles.more_wr}>
          <button 
            type="button"
            className={jnstyls([styles.more, bstyle.cta_link])}
            onClick={(e)=> setOpen(!open)}
          >
            READ MORE
          </button>
        </div>
      )}
    </div>
  )
}

export default Multicol